import { Button } from '@mui/material'
import { GridFooter, GridFooterContainer, GridPaginationModel, GridSlotProps } from '@mui/x-data-grid'
import { JSXElementConstructor } from 'react'
import { useTranslation } from 'react-i18next'

type FooterProps = GridSlotProps['footer']

interface Props extends FooterProps {
  pagination: GridPaginationModel
  setPagination: (paginationn: GridPaginationModel) => void
  disabledPreview: boolean
  disabledNext: boolean
}

const Footer = (({ pagination, setPagination, disabledPreview, disabledNext }: Props) => {
  const { t } = useTranslation()
  return (
    <GridFooterContainer>
      <GridFooter sx={{ '& .MuiTablePagination-actions': { display: 'none' } }} />
      <div style={{ display: 'flex' }}>
        <Button onClick={() => setPagination({ ...pagination, page: pagination.page - 1 })} disabled={disabledPreview}>
          {t('common.previous')}
        </Button>
        <Button onClick={() => setPagination({ ...pagination, page: pagination.page + 1 })} disabled={disabledNext}>
          {t('common.next')}
        </Button>
      </div>
    </GridFooterContainer>
  )
}) as JSXElementConstructor<GridSlotProps['footer']>

export default Footer
